(function ($) {
  $(document).ready(function () {
    if ($(".timeline-slider").length > 0) {
      setTimeout(function () {
        $(".timeline-slider .wrapper").css({opacity: "1"});
      }, 500);
      $(".timeline-slider .wrapper ").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        // fade: true,
        asNavFor: ".timeline-slider .slider-nav",
        infinite: false,
      });
      $(".timeline-slider .slider-nav").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".timeline-slider .wrapper",
        dots: false,
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        focusOnSelect: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              draggable: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              arrows: false,
            },
          },
        ],
      });
    }
  });
})(jQuery);
